export default __webpack_public_path__ + "static/media/jogja_karier.94935d2a.png";